import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { Flex, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { SuggestedEmptyIllustration } from '../assets/SuggestedEmptyIllustration';

const messages = defineMessages({
	suggestedEmptyDescription: {
		id: 'ai-audio.playlist-suggested.empty.description',
		defaultMessage: "We'll have suggestions here soon based on your activity.",
		description: 'Description shown when the suggested items section is empty',
	},
});

const styles = cssMap({
	container: {
		flex: 1,
		justifyContent: 'center',
		textAlign: 'center',
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		flexGrow: 1,
	},
	content: {
		width: '290px',
		textAlign: 'center',
		paddingLeft: token('space.400'),
		paddingRight: token('space.400'),
	},
});

export const SuggestedEmptyView = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<Flex
			xcss={styles.container}
			justifyContent="center"
			alignItems="center"
			rowGap="space.200"
			direction="column"
		>
			<SuggestedEmptyIllustration />
			<Flex xcss={styles.content} alignItems="center" rowGap="space.150" direction="column">
				<Text size="medium" color="color.text.subtlest">
					{formatMessage(messages.suggestedEmptyDescription)}
				</Text>
			</Flex>
		</Flex>
	);
};
